'use client'

import { MotionConfig, motion } from 'framer-motion'

/*
 * Scroll reveals. Tokens mirror --ease-out, --dur-reveal, --stagger and
 * --reveal-distance in app/globals.css; keep the two in sync.
 *
 * [data-reveal] wrappers SSR hidden (opacity 0). globals.css shows them when
 * JS is off (html:not(.js)) or the user prefers reduced motion.
 */
const transition = { duration: 0.55, ease: [0.16, 1, 0.3, 1] }
const viewport = { once: true, amount: 0.1, margin: '0px 0px -6% 0px' }

const variants = {
    slideUp: { hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition } },
    fadeIn: { hidden: { opacity: 0, y: 12 }, visible: { opacity: 1, y: 0, transition } },
}

const stagger = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.06, delayChildren: 0.05 } },
}

// Root wrapper: every framer animation honors prefers-reduced-motion
export function MotionProvider({ children }) {
    return <MotionConfig reducedMotion="user">{children}</MotionConfig>
}

export function AnimatedElement({ variant = 'slideUp', delay = 0, ...props }) {
    const { hidden, visible } = variants[variant]
    return (
        <motion.div
            data-reveal=""
            initial="hidden"
            whileInView="visible"
            viewport={viewport}
            variants={{ hidden, visible: { ...visible, transition: { ...transition, delay } } }}
            {...props}
        />
    )
}

// Reveals its StaggerItem children one after another
export function StaggerContainer(props) {
    return <motion.div initial="hidden" whileInView="visible" viewport={viewport} variants={stagger} {...props} />
}

export function StaggerItem(props) {
    return <motion.div data-reveal="" variants={variants.slideUp} {...props} />
}
